import { jurisdictionsRoutes } from '@routes/jurisdictions';

import { formatRegDate } from '../helpers';

/**
 * @typedef {Object} RegistrationsListApiData
 * @property {RegistrationApiData[]} results Registrations data
 */

/**
 * @typedef {Object} RegistrationsListItem
 * @property {string} id Registration ID
 * @property {string} name Jurisdiction name
 * @property {string} iso Jurisdiction ISO code
 * @property {string} regNo Registration number
 * @property {string} regDate Registration date
 * @property {string} deregDate Deregistration date
 * @property {string} localVatNo Local VAT number
 * @property {boolean} isUnmanaged Whether account is managed by us
 */

/**
 * @typedef {RegistrationsListItem[]} RegistrationsList
 */

/**
 * Model to transform incoming registrations list data
 * @param {RegistrationsListApiData} [data={}] API data
 * @returns {RegistrationsList} Transformed data
 */
export const registrationsListModel = (entityId, entityJurisdictionId, data = {}) =>
  data.results?.map(registration => ({
    name: registration.country?.name,
    id: registration.id,
    iso: registration.country?.iso,
    regNo: registration.number,
    regDate: formatRegDate(registration.dateRegistration),
    deregDate: formatRegDate(registration.dateRegistrationClosed),
    localVatNo: registration.numberLocal,
    regType: registration.registrationSubTypeDisplay,
    to: jurisdictionsRoutes.REG_DETAIL.make(entityId, entityJurisdictionId, registration.id),
    isUnmanaged: registration.isNotManagedByUs,
  })) || [];
